import { useEffect } from "react";
import { useAdvanceSearchContext } from "./AdvanceSearchContext";
import { Tabs } from "react-bootstrap";
import { Tab } from "bootstrap";
import ResultTab from "./ResultTab";
import Heading from "./Heading";
import SearchTab from "./SearchTab";
import Pagination from "../../../components/Pagination";
import "./inputs.css";

function InterviewAdvanceSearch() {
  const {
    activeTab,
    setActiveTab,
    t,
    totalpages,
    setPageNumber,
    pageNumber,
    setPageSize
  } = useAdvanceSearchContext();

  useEffect(() => (document.title = t("AtVitae - Advanced Search")), [t]);

  return (
    <>
      <Heading />
      <div className="row">
        <Tabs
          defaultActiveKey="search"
          activeKey={activeTab}
          onSelect={(tab) => setActiveTab(tab)}
          id="advanceSearch"
          className="mb-3"
        >
          <Tab eventKey="search" title={t("Search")}>
            <SearchTab />
          </Tab>
          <Tab eventKey="searchResults" title={t("Result")}>
            <ResultTab />
          </Tab>
        </Tabs>
        <div className="row">
          <div>
            {activeTab === "searchResults" && (
              <Pagination
                totalPages={totalpages}
                setPageNumber={setPageNumber}
                pageNumber={pageNumber}
                numberOfButtons={3}
                setPageSize={setPageSize}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default InterviewAdvanceSearch;
